import { render, staticRenderFns } from "./LogList.vue?vue&type=template&id=8b39f4ae&scoped=true&"
import script from "./LogList.vue?vue&type=script&lang=js&"
export * from "./LogList.vue?vue&type=script&lang=js&"
import style0 from "./LogList.vue?vue&type=style&index=0&id=8b39f4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b39f4ae",
  null
  
)

export default component.exports